<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="ap_code,pr_code,pr_detail,pr_orispeccode"
      placeholder="输入单据编号、物料进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.ap_id"
        :to="'/purchase/apply/'+item.ap_id"
      >
        <div class="weui-cell__bd">
          <p>{{item.ap_code}}</p>
          <p class="list-item-muted">{{item.ap_date}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.pr_detail}}&nbsp;{{item.pr_spec}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.ap_status!='已审核'}"
          >{{item.ap_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}单</label>
    </div>
    <add-button to="/purchase/apply_edit" />
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/purchase/application/list",
      filters: [
        {
          type: "date",
          name: "ap_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
              mode: "DETAIL"
            },
            {
              value: 1,
              label: "待转采购",
              condition: "ap_status='已审核' and ifnull(ad_status,' ')<>'已关闭' and ad_qty>ifnull(ad_yqty,0)",
              mode: "DETAIL"
            },
            {
              value: 2,
              label: "已转采购",
              condition: "ap_status='已审核' and ifnull(ad_qty,0)=ifnull(ad_yqty,0)",
              mode: "DETAIL"
            },
            {
              value: 3,
              label: "已取消",
              condition: "IFNULL(ad_status,' ')='已关闭'",
              mode: "DETAIL"
            }
          ]
        }
      ]
    };
  }
};
</script>